import HijriDate from "./HijriDate";
import React from "react";
import moment from 'moment';
import {useQueryParam, NumberParam} from "use-query-params";

const CurrentDateDisplay = ({tick, hijri}) => {
    const time = moment();
    const [offset] = useQueryParam('offset', NumberParam);

    var dayplus = time > hijri.dateChangeTime


    return (
        <div className={'date'}>
            <div className={'date2'}>
                {time.format("dddd, MMMM Do")}
            </div>
            <div className={'date-hijri'}>
                <HijriDate dayplus={dayplus} day={hijri.day} month={hijri.month} year={hijri.year} offset={offset || 0}/>
            </div>
        </div>
    );
};

export default CurrentDateDisplay;
